import React from 'react';
import { ResultContainer, Title, ResultScore, ResultText, Button } from '../styles/StyledComponents';

interface ResultScreenProps {
  score: number;
  highScore: number;
  coins: number;
  onRestart: () => void;
  onMainMenu: () => void;
}

const ResultScreen: React.FC<ResultScreenProps> = ({
  score,
  highScore,
  coins,
  onRestart,
  onMainMenu
}) => {
  const isNewHighScore = score > highScore;

  return (
    <ResultContainer>
      <Title>게임 종료</Title>
      
      <ResultScore>{score}</ResultScore>
      
      {isNewHighScore && (
        <ResultText>새로운 최고 점수!</ResultText>
      )}
      
      <ResultText>획득한 코인: {coins}</ResultText>
      
      <Button onClick={onRestart}>다시 시작</Button>
      <Button onClick={onMainMenu}>메인 메뉴</Button>
    </ResultContainer>
  );
};

export default ResultScreen;
